import React, { Component } from 'react'

import Gravatar from 'react-gravatar'

export default class Header extends Component {
    render() {
        return (
            <header className="z-20 h-16 px-4 md:px-0 text-grey-light w-screen md:w-full fixed">
                <div className="container mx-auto h-full flex items-center justify-between">
                    <a href="mail" className="rounded-full h-8 w-8 overflow-hidden shadow hover:shadow-md">
                        <Gravatar email="filingr000ve@gmail.com" />
                    </a>
                    <div className="links">
                        <a href="#about" className="text-grey-light hover:text-grey-lighter no-underline mx-3 text-xl md:text-base">About</a>
                        <a href="#work" className="text-grey-light hover:text-grey-lighter no-underline mx-3 text-xl md:text-base">Work</a>
                    </div>
                </div>
            </header>
        )
    }
}